export default __webpack_public_path__ + "media/titles/title_4_locale_fr-eaa53c56.png";